/**
 * Models for the vendor quote intake form submission payload.
 * Matches the backend API contract from the legacy app.
 */

export interface IntakeFormFields {
  submissionProtocol?: typeof VERIFIED_VENDOR_SUBMISSION_PROTOCOL;
  files: IntakeFile[];
  translation: TranslationParams;
  additionalFields: IntakeFormAdditionalFields;
}

export const VERIFIED_VENDOR_SUBMISSION_PROTOCOL = 'verified-uploads-v1';

export interface VendorSubmissionStatus {
  jobUid: string;
  submissionProtocol: typeof VERIFIED_VENDOR_SUBMISSION_PROTOCOL;
  status: 'PENDING' | 'FINALIZING' | 'ACCEPTED' | 'FAILED' | 'UNKNOWN' | 'CANCELLED';
  notification: 'NOT_ATTEMPTED' | 'SENDING' | 'SENT' | 'FAILED' | 'UNKNOWN';
  error?: string;
}

export interface IntakeFile {
  fileName: string;
  originalName: string;
  fileType?: string;
  size?: number;
  isDtpFile?: boolean;
}

export interface TranslationParams {
  sourceLanguage: string;
  targetLanguage: string;
  contentType: string;
  uploadType: string;
  jobName?: string;
}

export interface IntakeFormAdditionalFields {
  therapeuticArea?: string;
  product?: string;
  translationCertificateRequired?: boolean;
  translationCertificateEmail?: string;
  annotatedMonographRequired?: boolean;
  targetAudience?: string;
  documentTone?: string;
  isUserInterfaceIncluded?: boolean;
  userInterfaceField?: string;
  deadline?: string;
  additionalInfo?: string;
  isDtpJob?: boolean;
  isAdHocService?: boolean;
  files?: string;
  costCentreCode?: string;
  dtpJobType?: string[];
}
